import { Component, Input } from '@angular/core';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { NeskoAbVerteilerDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { of } from 'rxjs';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktNeskoabGrundstueckComponent } from '../../../shared/kompaktdarstellung/neskoab/kompakt-neskoab-grundstueck.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-neskoab-grundstueck-eigentum',
  templateUrl: './neskoab-grundstueck-eigentum.component.html',
  styleUrls: ['./neskoab-grundstueck-eigentum.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    KompaktNeskoabGrundstueckComponent,
    TranslatePipe,
    BetragPipe,
    DecimalHochkommaPipe
  ]
})
export class NeskoabGrundstueckEigentumComponent {
  _eigentum: Array<NeskoAbVerteilerDetailEntryMeta>;

  listLoader: ListLoader<NeskoAbVerteilerDetailEntryMeta>;

  @Input()
  hasRight = false;
  @Input()
  eigentumsform: string;

  constructor() {}

  @Input()
  set eigentum(value: Array<NeskoAbVerteilerDetailEntryMeta>) {
    if (!value) {
      return;
    }
    this.listLoader = new ListLoaderObservable<NeskoAbVerteilerDetailEntryMeta>(undefined, 1, of(value));
    this._eigentum = value;
  }
}
